module.exports = __webpack_public_path__ + "img/vertical_7_7_5012.c0f6dc7a.png";